import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDanhMucNhanVien } from '../../services/danhmuc';
import { NhanVienResponse } from '@app/models/nhanvien/NhanVien';
import { phongBan } from '../../constants';

export const convertDataSelectBox = (data: any) => {
    let rs: Array<DataSelectBox> = [];
    if (data) {
        rs = data.map((_item: NhanVienResponse) => {
            return {
                value: _item.id,
                label: _item.hoTen + " - " + _item.tenChucVu + " - " + _item.tenDonVi
            }
        });
    }
    return rs;
}
const BanGiamDocSelectBox = ({ value, disabled, multiple, allowClear, onChange }: { value?: number | number[], disabled?: boolean, multiple?: boolean, allowClear?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDanhMucNhanVien();
            let bgd = rs.filter((item:any) => item.idDonVi == phongBan.banGiamDoc)
            setData(convertDataSelectBox(bgd));
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        multiple ?
            <Select
                style={{ width: '100%' }}
                showSearch
                placeholder="--Chọn nhân sự--"
                filterOption={function (search, item: any) {
                    return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                }}
                value={value}
                options={data}
                disabled={disabled}
                mode='multiple'
                allowClear={allowClear}
                onChange={(e) => {
                    onChange({
                        target: {
                            value: e
                        }
                    })
                }}
            /> :
            <Select
                style={{ width: '100%' }}
                showSearch
                placeholder="--Chọn nhân sự--"
                filterOption={function (search, item: any) {
                    return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                }}
                value={value}
                options={data}
                disabled={disabled}
                allowClear={allowClear}
                onChange={(e) => {
                    onChange({
                        target: {
                            value: e
                        }
                    })
                }}
            />
    );
};

export default BanGiamDocSelectBox;
